<script setup>
import { ref, watch } from "vue"
import { useMutation } from "@vue/apollo-composable"
import UPDATE_USER_MUTATION from "@/graphql/User/UpdateUserMutation.gql"

const props = defineProps({
  user: {
    type: String,
  },
})

//initial values & watcher
const paramsHasChanges = ref(false)
const alertMessage = ref(null)
const alertType = ref(null)
const params = ref(
  props.user.userDetails.defaultRedirectParameters
    ? JSON.parse(props.user.userDetails.defaultRedirectParameters)
    : {
        kw: null,
        s1: null,
        s2: null,
        s3: null,
        s4: null,
        s5: null,
      },
)

//mutation update
const { mutate: updateUser, loading: isLoadingUserUpdate } =
  useMutation(UPDATE_USER_MUTATION)

const handleUpdateRedirectParams = () => {
  updateUser({
    input: {
      id: props.user.id,
      userDetails: {
        update: {
          id: props.user.userDetails.id,
          defaultRedirectParameters: JSON.stringify({
            kw: params.value.kw,
            s1: params.value.s1,
            s2: params.value.s2,
            s3: params.value.s3,
            s4: params.value.s4,
            s5: params.value.s5,
          }),
        },
      },
    },
  })
    .then(() => {
      alertMessage.value = "Redirect Params Updated Successfully."
      alertType.value = "success"
    })
    .catch(error => {
      console.log(error)
      alertMessage.value = "Failed to update Redirect Params."
      alertType.value = "error"
    })
}

watch(
  () => params.value,
  (newVal, oldVal) => {
    paramsHasChanges.value =
      JSON.stringify(newVal) == JSON.stringify(params.value)
    alertMessage.value = null
    alertType.value = null
  },
  { deep: true },
)
</script>
<template>
  <form
    @submit.prevent="handleUpdateRedirectParams"
    class="grid grid-cols-1 md:grid-cols-7 gap-x-12 gap-y-6"
  >
    <div
      class="col-start-1 row-start-7 md:col-start-4 md:row-start-1 md:col-span-4"
    >
      <XButton
        v-if="paramsHasChanges && !alertMessage"
        color="accent"
        type="submit"
        class="md:w-50"
        :isLoading="isLoadingUserUpdate"
        >Update Redirect Params</XButton>
      <Alert
        v-if="alertMessage"
        :isShowing="alertMessage"
        :alertMessage="alertMessage"
        :type="alertType"
      />
    </div>
    <div
      v-for="(value, key) in params"
      :key="key"
      class="md:col-start-1 md:col-span-3"
    >
      <XInput
        v-model="params[key]"
        :id="`structure-${key}`"
        :label="key.toUpperCase()"
        type="text"
        requiredIconHidden="true"
      />
    </div>
  </form>
</template>
